import apiClient from './apiClient';

export const loginAdmin = (userid, password) =>
  apiClient.post('/api/User/AdminLogin', { userid, password });